import FileRendererBlob, {type FileRendererBlobData} from '@github-ui/file-renderer-blob'
import {IncludeFragment} from '@github-ui/include-fragment-react'
import type {SafeHTMLString} from '@github-ui/safe-html'
import {VerifiedHTMLDiv} from '@github-ui/safe-html/VerifiedHTML'
import {Spinner} from '@primer/react'

export function RichDiff({
  dependencyDiffPath,
  fileRendererInfo,
  proseDiffHtml,
  loading,
}: {
  dependencyDiffPath?: string
  fileRendererInfo?: FileRendererBlobData
  loading: boolean
  proseDiffHtml?: SafeHTMLString
}) {
  if (loading) {
    return (
      <div className="d-flex flex-justify-center tmp-p-4">
        <Spinner size="large" />
      </div>
    )
  }

  if (proseDiffHtml) {
    return (
      /* eslint-disable-next-line @github-ui/github-monorepo/no-global-classname-literals */
      <div className="prose-diff position-relative">
        <VerifiedHTMLDiv html={proseDiffHtml} />
      </div>
    )
  } else if (fileRendererInfo) {
    return <FileRendererBlob {...fileRendererInfo} />
  } else if (dependencyDiffPath) {
    return (
      <IncludeFragment src={dependencyDiffPath}>
        <div className="text-center tmp-py-3">
          <Spinner size="medium" />
          {/* eslint-disable-next-line @github-ui/dotcom-primer/no-title-case -- baselined during linter rollout */}
          <p className="color-fg-muted my-2">Loading Dependency Review...</p>
        </div>
      </IncludeFragment>
    )
  } else {
    return <div className="d-flex flex-justify-center tmp-p-4">This rich diff is not supported at the moment.</div>
  }
}
